import { useLayoutEffect } from "react";

import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";

const links = [
  {
    to: "/layout?headerVariant=sticky",
    label: "Sticky page without much content",
  },
  {
    to: "/layout?headerVariant=sticky&loremipsum=true",
    label: "Sticky page with content",
  },
  {
    to: "/layout?headerVariant=sticky&loremipsum=true&pageStickyHeader=true",
    label: "Sticky page with content and sticky page header",
  },
  {
    to: "/layout?headerVariant=sticky&loremipsum=true&pageHeader=true&pageStickyHeader=true",
    label: "Sticky page with content, page header, and sticky page header",
  },
  {
    to: "/layout?headerVariant=semi-sticky",
    label: "Semi-sticky page without much content",
  },
  {
    to: "/layout?headerVariant=semi-sticky&loremipsum=true",
    label: "Semi-sticky page with content",
  },
  {
    to: "/layout?headerVariant=semi-sticky&loremipsum=true&pageStickyHeader=true",
    label: "Semi-sticky page with content and page sticky header",
  },
  {
    to: "/layout?headerVariant=semi-sticky&loremipsum=true&pageHeader=true&pageStickyHeader=true",
    label: "Semi-sticky page with content, page header, and sticky page header",
  },
];

export const MockLayoutNavigation = () => {
  useLayoutEffect(() => {
    document.documentElement.style.colorScheme = "light";
  }, []);

  return (
    <Grid item>
      <h2>Examples of page layout options:</h2>
      <ul>
        {links.map(({ to, label }, index) => (
          <li key={`example-${index}`}>
            <Link key={to} to={to}>
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </Grid>
  );
};
